<div class="close-button" (click)="gotoMainSite()">
	<div class="cross">
		<div class="line-v"></div>
		<div class="line-h"></div>
	</div>
</div>
<dodo-info-dialog-layout class ="infoDialogWidth"
[source]="_source">

	<div class="content" content>
		<div class="header">
			<div class="title">
				<img src="assets/img/icons/alert-triangle.svg"/>
				ID Verification Unsuccessful
			</div>
		</div>
		<div>Sorry, your ID verification has been unsuccessful and unfortunately we're unable to proceed with your order.</div>
		<div>Want to check your refund eligibility? Visit our <a class="support" href="https://www.dodo.com/support/mobile/getting-started#can-i-get-refund-store-bought-sim-card" target="_blank">support page</a>.</div>
		<div class="line"></div>
		<div class="actions">
			<button class="email-button" (click)="gotoMainSite()">
                Return to dodo.com
            </button>
		</div>
		
	</div>
</dodo-info-dialog-layout>
